import * as AT from '../actions/_types'
import { patientFilters } from '../constants'

const defaultState = {
  allLocations: false,
  currentPage: 0,
  doctors: [],
  error: null,
  filters: patientFilters,
  groups: [],
  hasStatusFilter: false,
  hasApptTypeFilter: false,
  isFetching: false,
  locations: [],
  patients: [],
  search: '',
  selectedMenu: { id: 'today', type: 'filters' },
  totalPages: 0,
  totalPatients: 0,
  view: 'list',
}

const patientGroups = (state = defaultState, action) => {
  switch (action.type) {
    case AT.PATIENTS_GROUPS_SELECT: {
      const reset = {}
      if (state.selectedMenu.id !== action.selectedMenu.id) {
        reset.patients = []
        reset.currentPage = 0
        reset.totalPages = 0
        reset.totalPatients = 0
      }
      return {
        ...state,
        ...reset,
        selectedMenu: action.selectedMenu,
        view: action.view,
      }
    }
    case AT.PATIENTS_GROUPS_UPDATE_SEARCH:
      return {
        ...state,
        search: action.search,
      }
    case AT.PATIENTS_GROUPS_UPDATE_ALL_LOCATIONS:
      return {
        ...state,
        allLocations: action.allLocations,
      }
    case AT.PATIENTS_GROUPS_CHANGE_VIEW:
      return {
        ...state,
        view: action.view,
      }
    case AT.PATIENTS_GROUPS_REQUEST:
      return {
        ...state,
        error: null,
        isFetching: true,
      }
    case AT.PATIENTS_GROUPS_REQUEST_FAILURE:
      return {
        ...state,
        error: action.error,
        isFetching: false,
      }
    case AT.PATIENTS_GROUPS_RECEIVE_PATIENTS: {
      const updatedState = {
        ...state,
        isFetching: false,
        totalPatients: action.totalPatients || 0,
        totalPages: action.totalPages || 0,
        currentPage: action.currentPage,
      }
      if (action.currentPage === 1) {
        updatedState.patients = action.patients
      } else {
        updatedState.patients = state.patients.concat(action.patients)
      }
      return updatedState
    }
    case AT.PATIENTS_GROUPS_RECEIVE_DOCTORS_AND_LOCATIONS_AND_STATUSES: {
      return {
        ...state,
        doctors: action.doctors,
        locations: action.locations,
        patientStatuses: action.statuses,
      }
    }
    case AT.PATIENTS_GROUPS_RECEIVE_GROUPS:
      return {
        ...state,
        groups: action.groups.map(group => ({
          id: group.id,
          name: group.name,
          param: 'group_ids[]',
          description: group.description,
          value: () => group.id,
        })),
      }
    case AT.PATIENTS_GROUPS_ADD_STATUS_FILTER: {
      return {
        ...state,
        hasStatusFilter: action.hasStatusFilter,
      }
    }
    case AT.PATIENTS_GROUPS_ADD_APPT_TYPE_FILTER: {
      return {
        ...state,
        hasApptTypeFilter: action.hasApptTypeFilter,
      }
    }
    default:
      return state
  }
}

export default patientGroups



// WEBPACK FOOTER //
// ./src/state/reducers/patient-groups.js